// Shared world currency catalog — flag, symbol, and display name for every currency
// tracked on the backend (/api/currency/rates). Used by NewTripModal + BudgetTracker.

export const CURRENCIES = [
  // Americas
  { code: "USD", flag: "🇺🇸", symbol: "$",   name: "US Dollar" },
  { code: "CAD", flag: "🇨🇦", symbol: "C$",  name: "Canadian Dollar" },
  { code: "MXN", flag: "🇲🇽", symbol: "MX$", name: "Mexican Peso" },
  { code: "BRL", flag: "🇧🇷", symbol: "R$",  name: "Brazilian Real" },
  { code: "ARS", flag: "🇦🇷", symbol: "AR$", name: "Argentine Peso" },
  { code: "CLP", flag: "🇨🇱", symbol: "CLP$",name: "Chilean Peso" },
  { code: "COP", flag: "🇨🇴", symbol: "COL$",name: "Colombian Peso" },
  { code: "PEN", flag: "🇵🇪", symbol: "S/",  name: "Peruvian Sol" },
  // Europe
  { code: "EUR", flag: "🇪🇺", symbol: "€",   name: "Euro" },
  { code: "GBP", flag: "🇬🇧", symbol: "£",   name: "British Pound" },
  { code: "CHF", flag: "🇨🇭", symbol: "CHF", name: "Swiss Franc" },
  { code: "SEK", flag: "🇸🇪", symbol: "kr",  name: "Swedish Krona" },
  { code: "NOK", flag: "🇳🇴", symbol: "kr",  name: "Norwegian Krone" },
  { code: "DKK", flag: "🇩🇰", symbol: "kr",  name: "Danish Krone" },
  { code: "PLN", flag: "🇵🇱", symbol: "zł",  name: "Polish Złoty" },
  { code: "CZK", flag: "🇨🇿", symbol: "Kč",  name: "Czech Koruna" },
  { code: "HUF", flag: "🇭🇺", symbol: "Ft",  name: "Hungarian Forint" },
  { code: "RON", flag: "🇷🇴", symbol: "lei", name: "Romanian Leu" },
  { code: "BGN", flag: "🇧🇬", symbol: "лв",  name: "Bulgarian Lev" },
  { code: "ISK", flag: "🇮🇸", symbol: "kr",  name: "Icelandic Króna" },
  { code: "TRY", flag: "🇹🇷", symbol: "₺",   name: "Turkish Lira" },
  { code: "UAH", flag: "🇺🇦", symbol: "₴",   name: "Ukrainian Hryvnia" },
  { code: "RUB", flag: "🇷🇺", symbol: "₽",   name: "Russian Ruble" },
  // Asia
  { code: "INR", flag: "🇮🇳", symbol: "₹",   name: "Indian Rupee" },
  { code: "JPY", flag: "🇯🇵", symbol: "¥",   name: "Japanese Yen" },
  { code: "CNY", flag: "🇨🇳", symbol: "¥",   name: "Chinese Yuan" },
  { code: "HKD", flag: "🇭🇰", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "TWD", flag: "🇹🇼", symbol: "NT$", name: "Taiwan Dollar" },
  { code: "KRW", flag: "🇰🇷", symbol: "₩",   name: "South Korean Won" },
  { code: "SGD", flag: "🇸🇬", symbol: "S$",  name: "Singapore Dollar" },
  { code: "THB", flag: "🇹🇭", symbol: "฿",   name: "Thai Baht" },
  { code: "MYR", flag: "🇲🇾", symbol: "RM",  name: "Malaysian Ringgit" },
  { code: "IDR", flag: "🇮🇩", symbol: "Rp",  name: "Indonesian Rupiah" },
  { code: "PHP", flag: "🇵🇭", symbol: "₱",   name: "Philippine Peso" },
  { code: "VND", flag: "🇻🇳", symbol: "₫",   name: "Vietnamese Đồng" },
  { code: "PKR", flag: "🇵🇰", symbol: "₨",   name: "Pakistani Rupee" },
  { code: "LKR", flag: "🇱🇰", symbol: "Rs",  name: "Sri Lankan Rupee" },
  { code: "BDT", flag: "🇧🇩", symbol: "৳",   name: "Bangladeshi Taka" },
  { code: "NPR", flag: "🇳🇵", symbol: "Rs",  name: "Nepalese Rupee" },
  // Middle East & Africa
  { code: "AED", flag: "🇦🇪", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SAR", flag: "🇸🇦", symbol: "﷼",   name: "Saudi Riyal" },
  { code: "QAR", flag: "🇶🇦", symbol: "﷼",   name: "Qatari Riyal" },
  { code: "KWD", flag: "🇰🇼", symbol: "د.ك", name: "Kuwaiti Dinar" },
  { code: "BHD", flag: "🇧🇭", symbol: ".د.ب",name: "Bahraini Dinar" },
  { code: "OMR", flag: "🇴🇲", symbol: "﷼",   name: "Omani Rial" },
  { code: "ILS", flag: "🇮🇱", symbol: "₪",   name: "Israeli Shekel" },
  { code: "EGP", flag: "🇪🇬", symbol: "£",   name: "Egyptian Pound" },
  { code: "ZAR", flag: "🇿🇦", symbol: "R",   name: "South African Rand" },
  { code: "NGN", flag: "🇳🇬", symbol: "₦",   name: "Nigerian Naira" },
  { code: "KES", flag: "🇰🇪", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "MAD", flag: "🇲🇦", symbol: "د.م.",name: "Moroccan Dirham" },
  // Oceania
  { code: "AUD", flag: "🇦🇺", symbol: "A$",  name: "Australian Dollar" },
  { code: "NZD", flag: "🇳🇿", symbol: "NZ$", name: "New Zealand Dollar" },
  { code: "FJD", flag: "🇫🇯", symbol: "FJ$", name: "Fijian Dollar" },
];

// Fast lookup by code
export const CURRENCY_BY_CODE = Object.fromEntries(CURRENCIES.map(c => [c.code, c]));

export const getCurrency = (code) => CURRENCY_BY_CODE[code] || { code, flag: "🌐", symbol: code + " ", name: code };

// Loose destination → default currency mapping. Matches country name substrings/city hints.
// Used to auto-suggest a trip currency from the "Destination" field.
const DEST_HINTS = [
  // Asia
  { rx: /japan|tokyo|kyoto|osaka|hokkaido/i, code: "JPY" },
  { rx: /china|beijing|shanghai|shenzhen|chengdu|xi'an|hangzhou/i, code: "CNY" },
  { rx: /hong kong/i, code: "HKD" },
  { rx: /taiwan|taipei/i, code: "TWD" },
  { rx: /korea|seoul|busan/i, code: "KRW" },
  { rx: /singapore/i, code: "SGD" },
  { rx: /thailand|bangkok|phuket|chiang mai|krabi/i, code: "THB" },
  { rx: /malaysia|kuala lumpur|penang|langkawi|malacca/i, code: "MYR" },
  { rx: /indonesia|bali|jakarta|lombok|yogyakarta/i, code: "IDR" },
  { rx: /philippines|manila|cebu|palawan|boracay/i, code: "PHP" },
  { rx: /vietnam|hanoi|saigon|ho chi minh|da nang|hoi an/i, code: "VND" },
  { rx: /india|delhi|mumbai|goa|jaipur|kerala|bangalore|kolkata/i, code: "INR" },
  { rx: /pakistan|karachi|lahore|islamabad/i, code: "PKR" },
  { rx: /sri lanka|colombo|kandy|galle/i, code: "LKR" },
  { rx: /bangladesh|dhaka/i, code: "BDT" },
  { rx: /nepal|kathmandu|pokhara/i, code: "NPR" },
  // Europe
  { rx: /uk|united kingdom|england|scotland|wales|london|edinburgh|manchester/i, code: "GBP" },
  { rx: /switzerland|zurich|geneva|bern|interlaken/i, code: "CHF" },
  { rx: /sweden|stockholm|gothenburg/i, code: "SEK" },
  { rx: /norway|oslo|bergen/i, code: "NOK" },
  { rx: /denmark|copenhagen/i, code: "DKK" },
  { rx: /iceland|reykjavik|reykjavík/i, code: "ISK" },
  { rx: /poland|warsaw|krakow|kraków|gdansk/i, code: "PLN" },
  { rx: /czech|prague/i, code: "CZK" },
  { rx: /hungary|budapest/i, code: "HUF" },
  { rx: /romania|bucharest/i, code: "RON" },
  { rx: /bulgaria|sofia/i, code: "BGN" },
  { rx: /turkey|istanbul|ankara|antalya|cappadocia/i, code: "TRY" },
  { rx: /ukraine|kyiv|kiev|odessa/i, code: "UAH" },
  { rx: /russia|moscow|saint petersburg|st\.? petersburg/i, code: "RUB" },
  // Euro zone (broad — put after specific matches so CHF/GBP win)
  { rx: /france|paris|nice|lyon|marseille|bordeaux/i, code: "EUR" },
  { rx: /germany|berlin|munich|frankfurt|hamburg/i, code: "EUR" },
  { rx: /italy|rome|milan|florence|venice|amalfi|tuscany|sicily/i, code: "EUR" },
  { rx: /spain|madrid|barcelona|seville|valencia|andalusia|mallorca|ibiza/i, code: "EUR" },
  { rx: /portugal|lisbon|porto|algarve|madeira/i, code: "EUR" },
  { rx: /greece|athens|santorini|mykonos|crete/i, code: "EUR" },
  { rx: /netherlands|amsterdam|rotterdam/i, code: "EUR" },
  { rx: /belgium|brussels|bruges|ghent/i, code: "EUR" },
  { rx: /austria|vienna|salzburg|innsbruck/i, code: "EUR" },
  { rx: /ireland|dublin|galway/i, code: "EUR" },
  { rx: /finland|helsinki/i, code: "EUR" },
  { rx: /estonia|latvia|lithuania|tallinn|riga|vilnius/i, code: "EUR" },
  { rx: /slovakia|slovenia|croatia|zagreb|ljubljana|bratislava|dubrovnik|split/i, code: "EUR" },
  // Middle East
  { rx: /uae|united arab emirates|dubai|abu dhabi/i, code: "AED" },
  { rx: /saudi|riyadh|jeddah|mecca|medina/i, code: "SAR" },
  { rx: /qatar|doha/i, code: "QAR" },
  { rx: /kuwait/i, code: "KWD" },
  { rx: /bahrain|manama/i, code: "BHD" },
  { rx: /oman|muscat|salalah/i, code: "OMR" },
  { rx: /israel|tel aviv|jerusalem/i, code: "ILS" },
  { rx: /egypt|cairo|luxor|aswan|sharm/i, code: "EGP" },
  // Africa
  { rx: /south africa|cape town|johannesburg|durban/i, code: "ZAR" },
  { rx: /nigeria|lagos|abuja/i, code: "NGN" },
  { rx: /kenya|nairobi|mombasa/i, code: "KES" },
  { rx: /morocco|marrakech|casablanca|fez|chefchaouen/i, code: "MAD" },
  // Americas
  { rx: /canada|toronto|vancouver|montreal|banff|whistler/i, code: "CAD" },
  { rx: /mexico|mexico city|cancun|tulum|oaxaca|playa del carmen/i, code: "MXN" },
  { rx: /brazil|rio|são paulo|sao paulo|salvador/i, code: "BRL" },
  { rx: /argentina|buenos aires|patagonia|mendoza/i, code: "ARS" },
  { rx: /chile|santiago|atacama/i, code: "CLP" },
  { rx: /colombia|bogota|medellin|cartagena/i, code: "COP" },
  { rx: /peru|lima|cusco|machu picchu/i, code: "PEN" },
  // Oceania
  { rx: /australia|sydney|melbourne|brisbane|perth|cairns|adelaide/i, code: "AUD" },
  { rx: /new zealand|auckland|wellington|queenstown/i, code: "NZD" },
  { rx: /fiji|nadi|suva/i, code: "FJD" },
  // US last so state names don't accidentally match earlier
  { rx: /usa|united states|new york|los angeles|san francisco|miami|chicago|hawaii|texas|california|boston|seattle|nashville/i, code: "USD" },
];

export function currencyFromDestination(destination) {
  if (!destination) return "USD";
  for (const h of DEST_HINTS) {
    if (h.rx.test(destination)) return h.code;
  }
  return "USD";
}
